const ConnectionState = {
    UNKNOWN: 'UNKNOWN',
    VALIDATING_CODE: 'VALIDATING_CODE',
    VALID_CODE: 'VALID_CODE',
    INVALID_CODE: 'INVALID_CODE',
    JOINING: 'JOINING',
    VALID_TEAM: 'VALID_TEAM',
    INVALID_TEAM: 'INVALID_TEAM',
    CONNECTING: 'CONNECTING',
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED'
};

const GameClientState = {
    ACCEPTING_REGISTRATIONS: 'ACCEPTING_REGISTRATIONS',
    READY_WAITING: 'READY_WAITING',
    INTRODUCE_CATEGORY: 'INTRODUCE_CATEGORY',
    INTRODUCE_QUESTION: 'INTRODUCE_QUESTION',
    AWAITING_TEAM_ANSWERS: 'AWAITING_TEAM_ANSWERS',
    REVEAL_CATEGORY_SCORES: 'REVEAL_CATEGORY_SCORES',
    REVEAL_FINAL_SCORES: 'REVEAL_FINAL_SCORES'
};

export default {
    ConnectionState,
    GameClientState
}